module.exports = __webpack_public_path__ + "img/fbhw.51d6902a.png";